import React, { useEffect, useState, useRef, useCallback } from 'react';
import "./ServiceMaster.css";
//import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import debounce from "lodash/debounce";
import Select from "react-select";
import { addService, addServices, getAllServices } from '../../../services/roleServiceMapService';

const ServiceMaster = () => {
  const navigate = useNavigate();
  const effectRan = useRef(false);
  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceNameArabic, setServiceNameArabic] = useState("");
  const [serviceLink, setServiceLink] = useState("");
  const [parentOptions, setParentOptions] = useState([]);
  const [parent, setParent] = useState(null);
  const [displayOrder, setDisplayOrder] = useState(1);
  const [allServices, setAllServices] = useState([]); // ✅ full list of services
  const [parentArabicLabel, setParentArabicLabel] = useState("");

  const Cancel = () => {
    navigate("/addService");
  };

  // const translateToArabic = async (value, setArabicState) => {
  //   if (value.trim() === "") {
  //     setArabicState("");
  //     return;
  //   }

  //   try {
  //     const response = await axios.get(
  //       `https://lingva.ml/api/v1/en/ar/${encodeURIComponent(value)}`
  //     );
  //     setArabicState(response.data.translation);
  //   } catch (error) {
  //     console.error("Translation failed:", error);
  //     setArabicState("خطأ في الترجمة");
  //   }
  // };

  // const debouncedTranslateServiceName = useCallback(
  //   debounce((value) => {
  //     translateToArabic(value, setServiceNameArabic);
  //   }, 500),
  //   []
  // );

  const handleServiceNameChange = (e) => {
    const value = e.target.value;
    setServiceName(value);
    // debouncedTranslateServiceName(value);
  };

  const handleServiceLink = (e) => {
    setServiceLink(e.target.value);
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/services`);
        //const data = response.data;
        const data = await getAllServices();
        setAllServices(data); // ✅ save full hierarchy for logic

        // Create dropdown options
        const options = [];

        data.forEach((service) => {
          options.push({
            value: service.serviceId,
            label: service.serviceName,
          });

          if (service.children && Array.isArray(service.children)) {
            service.children.forEach((child) => {
              options.push({
                value: child.serviceId,
                label: `${child.serviceName}`,
              });
            });
          }
        });

        setParentOptions(options);
      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };
    if (!effectRan.current) {
      fetchServices();
    }
    return ()=>{
      effectRan.current= true;
    }

  }, []);

  useEffect(() => {
    const fetchNextServiceId = async () => {
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/services`);
        const data = await getAllServices();
        const flatten = [];

        data.forEach((service) => {
          flatten.push(service);
          if (service.children?.length) {
            flatten.push(...service.children);
          }
        });

        const maxId = flatten.reduce(
          (max, item) => (item.serviceId > max ? item.serviceId : max),
          0
        );

        setServiceId(maxId + 1);
      } catch (error) {
        console.error("Failed to fetch max serviceId:", error);
      }
    };

    fetchNextServiceId();
  }, []);

  const getNextDisplayOrder = (parentId) => {
    let count = 0;

    if (!parentId) {
      // Root services (no parent)
      count = allServices.filter(service => !service.parent).length;
    } else {
      const parentService = allServices.find(s => s.serviceId === parentId);
      if (parentService?.children?.length) {
        count = parentService.children.length;
      }
    }

    return count + 1;
  };

  const handleAdd = async () => {
    try {
      const payload = {
        serviceName,
        serviceLink: serviceLink || '#',
        displayOrder,
        ...(parent && {
          parent: { serviceId: parent }
        })
      };

      //const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/services`, payload);
      const response = await addServices(payload);
      console.log("Service added:", response.data);
      navigate("/addService");
    } catch (error) {
      console.error("Failed to add service:", error);
      alert("Something went wrong while adding the service.");
    }
  };

  return (
    <div className="service-image-main">
      <h2>Add Service Master</h2>
      <div>
        {/* Service ID */}
        <div className="service-image">
          <div className={`service-input-group ${serviceId ? "filled" : ""}`}>
            <input type="text" value={serviceId} readOnly />
            <label>Service ID</label>
          </div>
          {/* <div className={`family-input-right ${serviceId ? "filled" : ""}`}>
            <input type="text" value={serviceId} readOnly dir="rtl" style={{ textAlign: "right" }} />
            <label>معرف الخدمة</label>
          </div> */}
        </div>

        {/* Service Name */}
        <div className="service-image">
          <div className={`service-input-group ${serviceName ? "filled" : ""}`}>
            <input type="text" value={serviceName} onChange={handleServiceNameChange} />
            <label>Service Name</label>
          </div>
          {/* <div className={`family-input-right ${serviceName ? "filled" : ""}`}>
            <input type="text" value={serviceNameArabic} readOnly dir="rtl" style={{ textAlign: "right" }} />
            <label>اسم الخدمة</label>
          </div> */}
        </div>

        {/* Parent ID */}
        <div className="service-image">
          <div className={`service-input-group ${parent ? "filled" : ""}`}>
            <Select
              options={parentOptions}
              value={parentOptions.find((opt) => opt.value === parent) || null}
              onChange={(selectedOption) => {
                const selectedParentId = selectedOption?.value ?? null;
                setParent(selectedParentId);
                setParentArabicLabel(selectedOption?.label || "");
                const nextOrder = getNextDisplayOrder(selectedParentId);
                setDisplayOrder(nextOrder);
              }}
              isClearable
              placeholder=""
              className="user-select"
              classNamePrefix="user-select"
            />
            <label>Parent Id</label>
          </div>
          {/* <div className={`family-input-right ${parent ? "filled" : ""}`}>
            <input type="text" value={parentArabicLabel} readOnly dir="rtl" style={{ textAlign: "right" }} />
            <label>معرف الوالد</label>
          </div> */}
        </div>

        {/* Service Link */}
        <div className="service-image">
          <div className={`service-input-group ${serviceLink ? "filled" : ""}`}>
            <input type="text" value={serviceLink} onChange={handleServiceLink} />
            <label>Service Link</label>
          </div>
          {/* <div className={`family-input-right ${serviceLink ? "filled" : ""}`}>
            <input type="text" value={serviceLink} readOnly dir="rtl" style={{ textAlign: "right" }} />
            <label>رابط الخدمة</label>
          </div> */}
        </div>

        {/* Display Order */}
        <div className="service-image">
          <div className={`service-input-group ${displayOrder ? "filled" : ""}`}>
            <input type="text" value={displayOrder} readOnly />
            <label>Display Order</label>
          </div>
          {/* <div className={`family-input-right ${displayOrder ? "filled" : ""}`}>
            <input type="text" value={displayOrder} readOnly dir="rtl" style={{ textAlign: "right" }} />
            <label>ترتيب العرض</label>
          </div> */}
        </div>
      </div>

      <div className='service-mst-btn'>
        <button className="add-btn-service-img" onClick={handleAdd}>Add</button>
        <button className="service-mst-cancel-img" onClick={Cancel}>Cancel</button>
      </div>
    </div>
  );
};

export default ServiceMaster;
